import { apiClient, signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export const getFetchPOAText = async ({
  credentials,
}: {
  credentials: CustomerCredentials;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/fmk/get-sign-text`,
    credentials,
  );

  const response = await apiClient(signedRequest);
  return response.data;
};

export const useGetFetchPOAText = ({
  credentials,
  enabled = true,
}: {
  credentials: CustomerCredentials;
  enabled?: boolean;
}) => {
  const fetchPOATextQuery = useQuery({
    queryKey: ["fetch-poa-text"],
    queryFn: () => getFetchPOAText({ credentials }),
    enabled,
    retry: 15,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "fetch-poa-text",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/fmk/get-sign-text",
        },
        level: "error",
      });
      return true;
    },
  });
  return fetchPOATextQuery;
};
